export default __webpack_public_path__ + "static/media/page1.57e8645a.png";